<template>
  <div style="height: 100%;">
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;">
      <span
        style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>水阀监测</span>
    </div>
    <div style="overflow-y: auto; height: 84%;margin-top: 4%;">
      <no-data style="margin-top: 20%;" v-if="data.length < 1"></no-data>
      <div style="height: 100%;width: 100%;display: flex;flex-direction: column;align-items: center" v-else>
        <div
          style="height: 125px;width: 284px;border-radius: 2px;border: 1px solid rgb(41,155,255,0.2);text-align: center;margin-bottom: 10px"
          :key="index" v-for="(item,index) in data">
          <div class="title">{{ item.name }}</div>
          <el-row style="height: 70%;width: 100%;display: flex">
            <el-col :span="11"
                    style="display: flex;flex-direction: row;align-items: center;justify-content: center;padding-top: 17px">
              <div style="width: 50%;height: 100%;text-align: right;padding-top: 5px">
                <img style="width: 32px;height: 33px" src="../../../assets/images/comprehensive/valve_water.png">
              </div>
              <div style="width: 50%;height: 100%;text-align: left;padding-left: 8px">
                <div :class="item.waterYield>=500?'waterValue':'waterWarningValue'">{{ item.waterYield }}</div>
                <div class="waterTitle">总用水量</div>
              </div>
            </el-col>
            <el-col :span="2"
                    style="height: 90%;display: flex;align-items: center;justify-content: center;flex-direction: row">
              <div style="height: 26px;width: 0;border: 1px solid #364149;"></div>
            </el-col>
            <el-col :span="11"
                    style="display: flex;flex-direction: row;align-items: center;justify-content: center;padding-top: 17px">
              <div style="width: 30%;height: 100%;text-align: right;padding-top: 5px">
                <img style="width: 32px;height: 33px" src="../../../assets/images/comprehensive/valve.png">
              </div>
              <div style="width: 50%;height: 100%;text-align: left;padding-left: 8px">
                <div>
                  <el-switch v-if="item.waterYield!=='-'" @change="change(item,index)"
                             v-model="item.open"
                             active-color="#00CFAC"
                             inactive-color="#F95453"
                             :active-value="activeValue"
                             :inactive-value="inactiveValue"
                             style="width: 90%;height: 24px">
                  </el-switch>
                  <div v-else :class="item.waterYield>=500?'waterValue':'waterWarningValue'">{{ item.waterYield }}</div>
                </div>
                <div class="waterTitle">阀门开关</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import NoData from "@/components/NoData";
import {getHistoryBySpacePoint} from "@/network/measuring-point-history";
import {controlPoint} from '@/network/device-measuring-point'

export default {
  name: "WaterValveMonitoring",
  components: {NoData},
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.data = []
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      data: [],
      value: '',
      typeList: ['PM_WV'],
      pointCodes: ['twc', 'controlvalve'],
      // 开关状态
      inactiveValue:0,
      activeValue:1
    }
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getSmoke:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getSmoke')
  },
  methods: {
    getData() {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        if (res.code === 0) {
          if (res.data.length > 0) {
            this.data = []
            res.data.forEach(item => {
              item.deviceInfoList.forEach(deviceList => {
                let data = {name: deviceList.name, waterYield: '-', open: '-', pointId: ''}
                deviceList.deviceMeasuringPointHistoryList.forEach(point => {
                  if (point.pointCode === 'twc') {
                    data.waterYield = point.pointValueName
                  }
                  if (point.pointCode === 'controlvalve') {
                    data.open = point.pointValueName
                    data.pointId=point.pointId
                  }
                })
                this.data.push(data)
              })
            })
          }
        }
      })
    },
    change(item,index) {
      this.controlPoint(item.pointId, Number.parseInt(item.open),index)
    },
    // 改变单机测点值
    controlPoint(pointId, value,index) {
      controlPoint(pointId, value).then(res => {
        if (res.code === 0) {
          this.data[index].open=value
          this.$message.success('操作水阀开关机成功！')
        }else{
          this.data[index].open=value === 0 ? 1 : 0
          this.$message.error('操作水阀开关机失败！')
        }
        this.$forceUpdate()
      })
    },
  }
}
</script>

<style scoped>
.title {
  font-size: 12px;
  font-weight: 400;
  color: #FFFFFF;
  padding-top: 20px;
  width: 100%;
}

.waterValue {
  font-size: 16px;
  font-weight: bold;
  color: #00D488;
}

.waterWarningValue {
  font-size: 16px;
  font-weight: bold;
  color: #F95453;
}

.waterTitle {
  font-size: 12px;
  font-weight: 400;
  color: #918b8b;
}

</style>
